import './styles/InstructionBox.scss';
import { useState, useEffect } from 'react';

//components
import SvgFramesAnimator from './SvgFramesAnimator';

//classes
import SvgFrameAnimatorSetting from '../classes/svgFrameAnimatorSetting';

// class AnimationProfile {
//     name: string = '';
//     framesCount: number = 0;

//     constructor(name: string, framesCount: number) {
//         this.name = name;
//         this.framesCount = framesCount;
//     }
// } ---deprecated
// class AnimationFrames {
//     name: string = '';
//     frames: any[] = [];

//     constructor(name: string, frames: any[]) {
//         this.name = name;
//         this.frames = frames;
//     }
// } ---deprecated

// const nonstate = {
//     animations: [
//         new AnimationProfile('successAnimation', 30),
//         new AnimationProfile('failAnimation', 30),
//         new AnimationProfile('repeatAnimation', 30),
//     ]
// } ---deprecated

interface Props {
    instructions: string[], SetInstructions: any,
    previews: string[], SetPreviews: any,
    SetNavBarShouldHide?: any,
    svgSettings: SvgFrameAnimatorSetting[],
    shouldSvgAnimations: string[],
    popupInstructAction: any, SetPopupInstructAction: any
}

//defers from messageBox, it's mainly for showing animated instructions, with back and forth navigations etc.
//it shall not handling any other action /confirmation features

const InstructionBox: React.FC<Props> = ({ instructions, SetInstructions, previews, SetPreviews, SetNavBarShouldHide, svgSettings, shouldSvgAnimations, popupInstructAction, SetPopupInstructAction }) => {
    //state
    const [page, SetPage] = useState(0);
    const [showHideInstructionBox, SetShowHideInstructionBox] = useState('hide');
    const [mountSvg, SetMountSvg] = useState(false);
    // const [animationFrames, SetAnimationFrames] = useState([] as AnimationFrames[]); ---attempt deprecated

    //watchers
    useEffect(() => {
        // if (nonstate.animations.length > 0) {
        //     const _animationFrames = [] as AnimationFrames[];
        //     nonstate.animations.map(async (animation: AnimationProfile, i) => {
        //         const frames = await LoadAnimationFrames(animation);

        //         _animationFrames.push(new AnimationFrames(
        //             animation.name, frames
        //         ));

        //         if (i == nonstate.animations.length - 1) {
        //             SetAnimationFrames([..._animationFrames]);
        //         }
        //     });
        // } ---load animation frames deprecated, moved to SvgFramesController
    }, []);

    useEffect(() => {
        if (instructions.length > 0) {
            SetShowHideInstructionBox('show');
            SetMountSvg(true);
            if (SetNavBarShouldHide != undefined)
                SetNavBarShouldHide(true);
        }
        else {
            SetMountSvg(false);
            SetShowHideInstructionBox('hide');
            if (SetNavBarShouldHide != undefined)
                SetNavBarShouldHide(false);
        }
    }, [instructions]);

    //test
    // useEffect(() => {
    //     console.log('checkSvgSettigns: ' + JSON.stringify(svgSettings));
    // }, [svgSettings]);

    //render functions
    const RenderAnimationPreview = () => {
        if (shouldSvgAnimations.length == 0 && previews.length > page) {
            return (<img className='InstructionBox-preview' src={previews[page]} />);
        } else if (mountSvg) {
            console.log('checksum: ' + shouldSvgAnimations.length);
            const svgSetting: SvgFrameAnimatorSetting = GetSvgSettingByAnimation(shouldSvgAnimations[page]);
            return (
                <div className='InstructionBox-preview borderless'>
                    <SvgFramesAnimator
                        frames={svgSetting.frames}
                        frameCount={svgSetting.framesCount}
                        fps={svgSetting.fps}
                        repeat={svgSetting.repeat}
                    />
                </div>
            )
        } else {
            return null
        }
    }
    const RenderButtonsPanel = () => {
        const buttons = [] as any[];

        if (instructions.length > 1) {
            buttons.push(
                <button className='InstructionBox-option-btn left' onClick={() => OnBackBtnClicked()}>back</button>
            )
            if (page < instructions.length - 1) {
                buttons.push(
                    <button className='InstructionBox-option-btn right' onClick={() => SetPage(page + 1)}>next</button>
                )
            } else {
                buttons.push(
                    <button className='InstructionBox-option-btn right' onClick={() => CloseAndResetMenu()}>done</button>
                )
            }
        } else {
            buttons.push(
                <button className='InstructionBox-option-btn fill' onClick={() => CloseAndResetMenu()}>done</button>
            );
        }

        return buttons;
    }

    //ui functions
    const OnBackBtnClicked = () => {
        if (page == 0) {
            CloseAndResetMenu();
        } else {
            SetPage(page - 1)
        }
    }

    //exe functions
    const GetSvgSettingByAnimation = (animationName: string) => {
        let svgSetting: SvgFrameAnimatorSetting = {} as SvgFrameAnimatorSetting;
        svgSettings.map((_svgSetting: SvgFrameAnimatorSetting) => {
            if (_svgSetting.animationName == animationName)
                svgSetting = _svgSetting;
        });

        return svgSetting;
    }
    const CloseAndResetMenu = () => {
        SetPage(0);
        SetInstructions([]);
        SetPreviews([]);
        SetPopupInstructAction(() => { }); //reset back to empty so next time will not cause error
    }

    return (
        <div className={'InstructionBox ' + (showHideInstructionBox)}>
            <div className='InstructionBox-body'>
                {
                    instructions.length > page ?
                        <span className='InstructionBox-instruction'>{instructions[page]}</span>
                        :
                        null
                }
                {
                    instructions.length > 0?
                    RenderAnimationPreview()
                    :
                    null
                }
                <div className='InstructionBox-option-panel'>
                    {
                        instructions.length > 0 ?
                        RenderButtonsPanel()
                        :
                        null
                    }
                </div>
            </div>
        </div>
    );
}
export default InstructionBox;